export const framePayLink = process.env.GATSBY_REBILLY_KEY;
